const $ = jQuery.noConflict();

class LocationSearch {
    init() {
        
        $('form#location-search').submit(function(event) {
            
            event.preventDefault();

            var formAction = $(this).attr('action');
            
            var zipCode = $('form#location-search input#location').val();
            
            var date = new Date();
            date.setTime(date.getTime()+(1000*60*60*24));
            var expires = date.toGMTString();
            
            document.cookie = 'wbw_zipcode='+zipCode+';expires='+expires+';path=/;';
            
            if (formAction) {
                window.location.href = formAction;
            }
            else {
                window.location.replace('/locations/');
            }
        });

        $('[data-clear-button]').on('click', function(event) {
            event.preventDefault();

            document.cookie = 'wbw_zipcode=0;Max-Age=-99999999;path=/;';
            
            location.reload();
        });
    }
}
export default new LocationSearch;
